import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Unsubscribe Success'

const config = {
  routes: {
    label: 'Unsubscribe Success',
    prefix: '/unsubscribe/success',
  },
  setup,
}

export default config
